var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isMobile()
      ? 'search-container-mobile'
      : _vm.isiPad()
      ? 'search-container-ipad'
      : 'search-container',attrs:{"id":"search-container"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],staticClass:"search-field",attrs:{"id":"searchInput","type":"search","placeholder":"Search"},domProps:{"value":(_vm.inputValue)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputValue=$event.target.value},_vm.onEntry]}})])}
var staticRenderFns = []

export { render, staticRenderFns }